import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import authReducer from '../reducers/auth';
import assistanceAgreementReducer from '../reducers/assistanceAgreement' ;
import legalInformationReducer from '../reducers/legalInformation' ;
import obituaryReducer from '../reducers/obituary' ;
import peopleToInformReducer from '../reducers/peopleToInform';
import organizationToContactReducer from '../reducers/organizationToContact' ;
import memoryChargedReducer from '../reducers/memoryCharged';
import alternateMemroyChargedReducer from '../reducers/alternateMemoryCharged';
import digitalChargedReducer  from '../reducers/digitalCharged';
import ceremonyReducer  from '../reducers/ceremony';
import otherProvisionReducer from '../reducers/otherProvision';
import conservationCareReducer from '../reducers/conservationCare';
import beneficiaryReducer from '../reducers/deneficiary';
import countryReducer from '../reducers/country';
import mesObsequesReducer from '../reducers/mesObseques';
import partenaireReducer from '../reducers/partenaire';
import stateHeadingsReducer from  '../reducers/StateHeadings' ;
import cguReducer from '../reducers/cgu';
import messageManagmentReducer from '../reducers/messageManagment';



const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      auth: authReducer,
      assistanceAgreementData:  assistanceAgreementReducer,
      legalInformationData : legalInformationReducer,
      obituaryData : obituaryReducer,
      peopleToInformData: peopleToInformReducer,
      organizationToContactData : organizationToContactReducer,
      memoryChargedData: memoryChargedReducer,
      alternateMemroyChargedData :alternateMemroyChargedReducer,
      digitalChargedData : digitalChargedReducer,
      ceremonyData : ceremonyReducer,
      otherProvisionData : otherProvisionReducer,
      conservationCareData: conservationCareReducer,
      beneficiaryData : beneficiaryReducer,
      countryData : countryReducer,
      mesObsequesData: mesObsequesReducer,
      partenaireData: partenaireReducer,
      stateHeadingsData : stateHeadingsReducer,
      cguData: cguReducer,
      messages : messageManagmentReducer
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js